export const Pricing = () => {
  return (
    <section id="pricing" data-testid="pricing-section" className="border-b border-[#1e293b]/50 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="rl-reveal mx-auto mb-16 max-w-xl text-center">
          <h2 className="mb-3 text-3xl font-bold text-white md:text-4xl">Simple transparent plans</h2>
          <p className="text-[#94a3b8]">Start building with our free tier, then scale to dedicated cores.</p>
        </div>

        <div className="mx-auto grid max-w-3xl grid-cols-1 gap-8 md:grid-cols-2">
          {/* Free Trial */}
          <div
            data-testid="pricing-card-trial"
            className="rl-reveal flex flex-col justify-between rounded-xl border border-[#1e293b] bg-[#0c121b] p-8 transition-colors hover:border-[#22d3ee]/40"
          >
            <div>
              <div className="mb-2 font-mono text-xs uppercase tracking-widest text-[#94a3b8]">Free Trial</div>
              <div className="mb-4 text-4xl font-bold text-white">
                $0 <span className="text-sm font-normal text-[#64748b]">/ 50 hours</span>
              </div>
              <p className="mb-6 text-sm text-[#94a3b8]">Perfect to test your coding agents with zero risk.</p>
              <ul className="mb-8 space-y-3 font-mono text-xs text-[#cbd5e1]">
                <li className="flex items-center gap-2"><span className="text-[#22c55e]">✓</span> 2 vCPU + 4GB RAM boxes</li>
                <li className="flex items-center gap-2"><span className="text-[#22c55e]">✓</span> Auto-sleep on idle</li>
                <li className="flex items-center gap-2"><span className="text-[#22c55e]">✓</span> Instant web terminals</li>
              </ul>
            </div>
            <a
              href="#waitlist"
              data-testid="pricing-trial-cta"
              className="block rounded border border-[#1e293b] py-2.5 text-center text-sm font-medium text-white transition-colors hover:border-[#22d3ee]"
            >
              Start Free Trial
            </a>
          </div>

          {/* Pro Developer */}
          <div
            data-testid="pricing-card-pro"
            className="rl-reveal relative flex flex-col justify-between rounded-xl border border-[#22d3ee]/60 bg-[#0d1624] p-8 shadow-xl shadow-[#22d3ee]/5"
          >
            <div className="absolute -top-3 right-6 rounded-full bg-[#22d3ee] px-2.5 py-0.5 font-mono text-xs font-bold uppercase text-[#090d12]">
              Popular
            </div>
            <div>
              <div className="mb-2 font-mono text-xs uppercase tracking-widest text-[#22d3ee]">Pro Developer</div>
              <div className="mb-4 text-4xl font-bold text-white">
                $20 <span className="text-sm font-normal text-[#64748b]">/ month + usage</span>
              </div>
              <p className="mb-6 text-sm text-[#94a3b8]">For heavy developers running multiple parallel agent flows.</p>
              <ul className="mb-8 space-y-3 font-mono text-xs text-[#cbd5e1]">
                <li className="flex items-center gap-2"><span className="text-[#22c55e]">✓</span> Up to 16 vCPU + 32GB RAM</li>
                <li className="flex items-center gap-2"><span className="text-[#22c55e]">✓</span> Custom Docker images</li>
                <li className="flex items-center gap-2"><span className="text-[#22c55e]">✓</span> Pay per second billing</li>
              </ul>
            </div>
            <a
              href="#waitlist"
              data-testid="pricing-pro-cta"
              className="block rounded bg-[#22d3ee] py-2.5 text-center text-sm font-semibold text-[#090d12] transition-colors hover:bg-[#67e8f9]"
            >
              Request Early Access
            </a>
          </div>
        </div>

        <p className="rl-reveal mx-auto mt-8 max-w-xl text-center font-mono text-xs text-[#64748b]">
          Sleeping machines are always free. Billed by the second, cancel anytime.
        </p>
      </div>
    </section>
  );
};
